/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

const COUNTRIES_LIST = ["US","GB","AU","IN","CA"];

class RegionLevelCountries {

    static is(cc) {
        return COUNTRIES_LIST.includes(cc.toUpperCase());
    }

    static complete(cc, region) {
        return cc.toUpperCase() + " / " + region;
    }

    static isPrefix(text) {
        const pos =  text.indexOf(" / ");
        if (pos === -1) return false;
        return this.is(text.substring(0, pos));
    }

    static getCC(text) {
        const pos =  text.indexOf(" / ");
        if (pos === -1) return null;
        return text.substring(0, pos);
    }

    static getRegion(text) {
        const pos =  text.indexOf(" / ");
        if (pos === -1) return null;
        return text.substring(pos+3);
    }

}

export default RegionLevelCountries;
